// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floating toggle button — fixed below waveform debug button */
.slide-fab {
    position: fixed;
    left: 12px;
    top: 52px;
    z-index: 99999;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
    transition: background 0.15s;
}

.slide-fab:hover {
    background: rgba(60, 120, 255, 0.75);
}

.slide-fab--active {
    background: rgba(60, 120, 255, 0.9);
}

/* 新着スライド通知 — 強調アニメーション（クリックを促す・しっかり目立たせる） */
.slide-fab--attention {
    background: rgba(60, 120, 255, 1);
    animation:
        slide-fab-pulse 1.1s ease-in-out infinite,
        slide-fab-bounce 1.1s ease-in-out infinite;
}

/* 拡がる二重リング（クリック誘導） */
.slide-fab--attention::before,
.slide-fab--attention::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 2px solid rgba(90, 150, 255, 0.9);
    animation: slide-fab-ring 1.6s ease-out infinite;
    pointer-events: none;
}

.slide-fab--attention::after {
    animation-delay: 0.8s;
}

.slide-fab--attention:hover {
    animation: none;
}

.slide-fab--attention:hover::before,
.slide-fab--attention:hover::after {
    animation: none;
    opacity: 0;
}

/* 本体の発光パルス（色も明滅） */
@keyframes slide-fab-pulse {
    0%,
    100% {
        background: rgba(60, 120, 255, 1);
        box-shadow: 0 0 6px 2px rgba(60, 120, 255, 0.6);
    }

    50% {
        background: rgba(120, 170, 255, 1);
        box-shadow: 0 0 18px 6px rgba(90, 150, 255, 0.95);
    }
}

/* 上下バウンス（目線を引く） */
@keyframes slide-fab-bounce {
    0%,
    100% {
        transform: translateY(0) scale(1);
    }

    50% {
        transform: translateY(-6px) scale(1.18);
    }
}

/* 波紋のように拡がるリング */
@keyframes slide-fab-ring {
    0% {
        transform: scale(1);
        opacity: 0.9;
    }

    100% {
        transform: scale(2.4);
        opacity: 0;
    }
}

/* 左下に展開する浮遊カード（ドラッグ移動＋リサイズ・暗幕なし） */
.slide-card {
    position: fixed;
    z-index: 600;
    display: flex;
    flex-direction: column;
    background: #1a1a1a;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.55);

    /* 閉じている時：非表示＋操作不可（開くとふわっとフェード＋少し上へ） */
    opacity: 0;
    transform: translateY(8px);
    pointer-events: none;
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.slide-card--open {
    opacity: 1;
    transform: translateY(0);
    pointer-events: all;
}

.slide-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    padding: 0 6px 0 10px;
    background: #222;
    color: #ddd;
    cursor: move;
    user-select: none;
    flex: 0 0 auto;
}

.slide-card__title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
}

.slide-card__title svg {
    width: 14px;
    height: 14px;
}

.slide-card__actions {
    display: flex;
    align-items: center;
    gap: 2px;
}

.slide-card__btn {
    width: 24px;
    height: 24px;
    background: transparent;
    color: #ccc;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
}

.slide-card__btn:hover {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
}

.slide-card__body {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
}

/* カード内では SlideViewer をカードいっぱいに広げる */
.slide-card .slide-viewer {
    width: 100%;
    height: 100%;
    border-radius: 0;
}

.slide-card .slide-viewer__canvas-wrapper {
    flex: 1 1 auto;
    min-height: 0;

    /* 親から渡す inline height:100% を打ち消して flex で埋める */
    height: auto !important;
}

/* 右下のリサイズグリップ */
.slide-card__resize {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 16px;
    height: 16px;
    cursor: nwse-resize;
    z-index: 2;
    background:
        linear-gradient(135deg, transparent 0 50%, rgba(255, 255, 255, 0.5) 50% 60%,
            transparent 60% 72%, rgba(255, 255, 255, 0.5) 72% 82%, transparent 82%);
}
`, "",{"version":3,"sources":["webpack://./react/features/slide-view/components/web/slide-panel.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;IACI,eAAe;IACf,UAAU;IACV,SAAS;IACT,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA,4CAA4C;AAC5C;IACI,iCAAiC;IACjC;;kDAE8C;AAClD;;AAEA,qBAAqB;AACrB;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,yCAAyC;IACzC,gDAAgD;IAChD,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,UAAU;AACd;;AAEA,mBAAmB;AACnB;IACI;;QAEI,iCAAiC;QACjC,+CAA+C;IACnD;;IAEA;QACI,kCAAkC;QAClC,iDAAiD;IACrD;AACJ;;AAEA,kBAAkB;AAClB;IACI;;QAEI,iCAAiC;IACrC;;IAEA;QACI,uCAAuC;IAC3C;AACJ;;AAEA,iBAAiB;AACjB;IACI;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;AACJ;;AAEA,mCAAmC;AACnC;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;;IAE1C,sCAAsC;IACtC,UAAU;IACV,0BAA0B;IAC1B,oBAAoB;IACpB,kDAAkD;AACtD;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,aAAa;AACjB;;AAEA,oCAAoC;AACpC;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;;IAEb,8CAA8C;IAC9C,uBAAuB;AAC3B;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV;;mFAE+E;AACnF","sourcesContent":["/* Floating toggle button — fixed below waveform debug button */\n.slide-fab {\n    position: fixed;\n    left: 12px;\n    top: 52px;\n    z-index: 99999;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border: none;\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.55);\n    color: #fff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);\n    transition: background 0.15s;\n}\n\n.slide-fab:hover {\n    background: rgba(60, 120, 255, 0.75);\n}\n\n.slide-fab--active {\n    background: rgba(60, 120, 255, 0.9);\n}\n\n/* 新着スライド通知 — 強調アニメーション（クリックを促す・しっかり目立たせる） */\n.slide-fab--attention {\n    background: rgba(60, 120, 255, 1);\n    animation:\n        slide-fab-pulse 1.1s ease-in-out infinite,\n        slide-fab-bounce 1.1s ease-in-out infinite;\n}\n\n/* 拡がる二重リング（クリック誘導） */\n.slide-fab--attention::before,\n.slide-fab--attention::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: 50%;\n    border: 2px solid rgba(90, 150, 255, 0.9);\n    animation: slide-fab-ring 1.6s ease-out infinite;\n    pointer-events: none;\n}\n\n.slide-fab--attention::after {\n    animation-delay: 0.8s;\n}\n\n.slide-fab--attention:hover {\n    animation: none;\n}\n\n.slide-fab--attention:hover::before,\n.slide-fab--attention:hover::after {\n    animation: none;\n    opacity: 0;\n}\n\n/* 本体の発光パルス（色も明滅） */\n@keyframes slide-fab-pulse {\n    0%,\n    100% {\n        background: rgba(60, 120, 255, 1);\n        box-shadow: 0 0 6px 2px rgba(60, 120, 255, 0.6);\n    }\n\n    50% {\n        background: rgba(120, 170, 255, 1);\n        box-shadow: 0 0 18px 6px rgba(90, 150, 255, 0.95);\n    }\n}\n\n/* 上下バウンス（目線を引く） */\n@keyframes slide-fab-bounce {\n    0%,\n    100% {\n        transform: translateY(0) scale(1);\n    }\n\n    50% {\n        transform: translateY(-6px) scale(1.18);\n    }\n}\n\n/* 波紋のように拡がるリング */\n@keyframes slide-fab-ring {\n    0% {\n        transform: scale(1);\n        opacity: 0.9;\n    }\n\n    100% {\n        transform: scale(2.4);\n        opacity: 0;\n    }\n}\n\n/* 左下に展開する浮遊カード（ドラッグ移動＋リサイズ・暗幕なし） */\n.slide-card {\n    position: fixed;\n    z-index: 600;\n    display: flex;\n    flex-direction: column;\n    background: #1a1a1a;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.55);\n\n    /* 閉じている時：非表示＋操作不可（開くとふわっとフェード＋少し上へ） */\n    opacity: 0;\n    transform: translateY(8px);\n    pointer-events: none;\n    transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.slide-card--open {\n    opacity: 1;\n    transform: translateY(0);\n    pointer-events: all;\n}\n\n.slide-card__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 32px;\n    padding: 0 6px 0 10px;\n    background: #222;\n    color: #ddd;\n    cursor: move;\n    user-select: none;\n    flex: 0 0 auto;\n}\n\n.slide-card__title {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.slide-card__title svg {\n    width: 14px;\n    height: 14px;\n}\n\n.slide-card__actions {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n}\n\n.slide-card__btn {\n    width: 24px;\n    height: 24px;\n    background: transparent;\n    color: #ccc;\n    border: none;\n    border-radius: 4px;\n    font-size: 13px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n}\n\n.slide-card__btn:hover {\n    background: rgba(255, 255, 255, 0.15);\n    color: #fff;\n}\n\n.slide-card__body {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n}\n\n/* カード内では SlideViewer をカードいっぱいに広げる */\n.slide-card .slide-viewer {\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n}\n\n.slide-card .slide-viewer__canvas-wrapper {\n    flex: 1 1 auto;\n    min-height: 0;\n\n    /* 親から渡す inline height:100% を打ち消して flex で埋める */\n    height: auto !important;\n}\n\n/* 右下のリサイズグリップ */\n.slide-card__resize {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 16px;\n    height: 16px;\n    cursor: nwse-resize;\n    z-index: 2;\n    background:\n        linear-gradient(135deg, transparent 0 50%, rgba(255, 255, 255, 0.5) 50% 60%,\n            transparent 60% 72%, rgba(255, 255, 255, 0.5) 72% 82%, transparent 82%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
